import Section from '../../enums/Sections';
import Translation from '../lang/Translation';
import {
  getDeliveryType,
  getSelectedDeliveryCountry,
  getSelectedPaymentOptionType,
} from '../selectors/selectors';
import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';
import V2Validation from '../validation/v2-validation';
import * as actionTypes from './action-types';
import {postcodeAnywhereShowFields, useExpressCheckoutAddress} from './address-actions';
import {switchToResidential} from './delivery-section-actions';
import {getDeliveryOptions} from './deliveryOptionActions';
import {checkEmailWithAPI, updateEmailAddress} from './emailAddressActions';
import {getOrderSummaryForCountry} from './orderSummaryActions';
import {setPageMessage} from './pageMessageActions';
import handleReturnedContactNumber from './paymentActions/expressCheckoutActions/handleReturnedContactNumber';
import {
  revertSectionOrder, stepForwards, stepToPage, updateSectionOrder,
} from './uiActions';
import stepToSection from './uiActions/stepToSection';

const setSessionStorage = (deliveryType) => {
  window.sessionStorage.setItem(`deliveryType-${window.start.orderNumber}`, deliveryType);
};

const setExpressCheckout = (isUsingExpressCheckout, index) => ({
  type: actionTypes.SET_USING_EXPRESS_CHECKOUT,
  isUsingExpressCheckout,
  index,
});

export const exitExpressCheckoutFlow = (reason, showPageMessage = false, stepToPayment = false) => (dispatch) => {
  if (showPageMessage) {
    dispatch(setPageMessage(Translation.getText('errors.hostedPaymentAuthenticationFailed')));
  }
  
  dispatch(setExpressCheckout(false, -1));
  
  dispatch(revertSectionOrder());
  
  if (stepToPayment) {
    dispatch(stepToSection(Section.PAYMENT));
  }
  
  try {
    doMetric('exitExpressCheckoutFlow', [{name: 'reason', value: reason}]);
  } catch (error) {
    Track.error(error);
  }
};

export const enterExpressCheckoutFlow = paymentMethod => (dispatch, getState) => {
  const expressOptionIndex = getState().payment?.options?.findIndex(paymentOption => paymentOption.name === paymentMethod);
  
  dispatch(setExpressCheckout(true, expressOptionIndex));
  try {
    doMetric('enterExpressCheckoutFlow', [{name: 'reason', value: 'Returned from PayPal'}]);
  } catch (error) {
    Track.error(error);
  }
};

const populateAddress = (address, dispatch) => new Promise((resolve) => {
  dispatch(useExpressCheckoutAddress(address));
  resolve();
});

export const handleReturnFromExpress = (address, contactNumber, shouldUpdateEmail, email, paymentOption) => (
  dispatch, getState,
) => {
  if (getSelectedDeliveryCountry(getState()) !== address.country) {
    dispatch(getOrderSummaryForCountry({value: address.country}));
  }
  
  if (shouldUpdateEmail) {
    dispatch(updateEmailAddress(email));
    dispatch(checkEmailWithAPI(email));
  }
  
  if (contactNumber) {
    dispatch(handleReturnedContactNumber(contactNumber));
  }
  
  if (getState().site.isPostcodeLookupEnabled) {
    dispatch(postcodeAnywhereShowFields('delivery', true));
  }
  
  populateAddress(address, dispatch).then(() => {
    const isFormValid = V2Validation.validate('deliveryAddressList').isValid;
    
    if (isFormValid) {
      if (getDeliveryType(getState()) === 'pudo') {
        dispatch(switchToResidential());
        setSessionStorage('residential');
        dispatch(getDeliveryOptions());
      }
      
      dispatch(updateSectionOrder());
      dispatch(stepForwards());
      
      if (getSelectedPaymentOptionType(getState()) === paymentOption) {
        dispatch(stepForwards());
      } else {
        dispatch(exitExpressCheckoutFlow('Error selecting express option'));
      }
    } else if (getState().ui.checkoutProgressStep !== 1) {
      dispatch(stepToPage(1));
    }
  });
};
